import { gql } from '../../../apollo/__generated__';

export const PLACES = gql(`
  query Places {
    places {
      id
      name
      address
      bedrooms {
        id
        floor
        doorNumber
        maxUsers
      }
    }
  }
`);
